// Standard Loader
//
// Used to load a list of assets from disk.
//
// If you want to change the subdirectory grpahics will be loaded from, use "setGraphicsResDirectory"
// --------------------------------------------

ReflexLoader = {};

ReflexLoader.isLoaded = false;
ReflexLoader.assetsToLoad = [];
ReflexLoader.resourceData = {};
ReflexLoader.rootDir = "graphics/";
ReflexLoader.resDir = "Generic/";
ReflexLoader.fatalError = false;
ReflexLoader.rootResDir = ReflexLoader.rootDir + ReflexLoader.resDir;

// ---------------------

ReflexLoader.fileAtlasData = {};
ReflexLoader.atlasesLoaded = {};

ReflexLoader.setGraphicsResDirectory = function (directoryName) {
  ReflexLoader.resDir = directoryName + "/";
  ReflexLoader.rootResDir =
    (gdk.serverParser.rootAssetPath || "") +
    ReflexLoader.rootDir +
    ReflexLoader.resDir;
};

ReflexLoader.loadAtlasDataFiles = function (atlasList, completeCallback) {
  var loadFunc = function (i) {
    if (i < atlasList.length) {
      ReflexLoader.atlasesLoaded[atlasList[i]] = { loaded: false };

      $.getJSON(atlasList[i], function (json) {
        for (var j in json.frames) {
          if (json.frames.hasOwnProperty(j)) {
            if (ReflexLoader.fileAtlasData[j]) {
              alert(
                "filename " +
                  j +
                  " already exists in atlas " +
                  ReflexLoader.fileAtlasData[j]
              );
            }
            ReflexLoader.fileAtlasData[j] = atlasList[i];
          }
        }
        loadFunc(i + 1);
      }).fail(function (jqxhr, status, error) {
        console.error("Failed to load Atlas file " + atlasList[i]);
        console.error(error.message);
      });
    } else {
      completeCallback();
    }
  };

  if (atlasList.length === 0) {
    // No atlas files to load
    completeCallback();
  } else {
    // Start loading atlas files
    loadFunc(0);
  }
};

// needed because the default spine loader assumes the atlas file is named the same as the json file
// but with the json and atlas getting renamed with the crc value they no longer match.
// similarly the image file needs to have its crc appended to the filename hence the new loader
ReflexLoader.createSpineMetadata = function (file) {
  let res = {};
  let atlasName = file;
  atlasName = atlasName.substr(0, atlasName.lastIndexOf(".")) + ".atlas";
  atlasName = gdk.ammendResourceName(atlasName);
  res.spineAtlasFile = atlasName;

  res.imageLoader = function (loader, namePrefix, baseUrl, imageOptions) {
    if (baseUrl && baseUrl.lastIndexOf("/") !== baseUrl.length - 1) {
      baseUrl += "/";
    }
    return function (line, callback) {
      var name = namePrefix + line;
      var url = baseUrl + line;
      url = gdk.ammendResourceName(url);
      var cachedResource = loader.resources[name];
      if (cachedResource) {
        function done() {
          callback(cachedResource.texture.baseTexture);
        }
        if (cachedResource.texture) {
          done();
        } else {
          cachedResource.onAfterMiddleware.add(done);
        }
      } else {
        loader.add(name, url, imageOptions, function (resource) {
          if (!resource.error) {
            callback(resource.texture.baseTexture);
          } else {
            callback(null);
          }
        });
      }
    };
  };
  return res;
};

ReflexLoader.startLoading = function (
  filesList,
  ID,
  progressCallback,
  completeCallback
) {
  var loader = new PIXI.loaders.Loader();
  var filesToLoad = 0;
  var i;
  var atlasName;

  for (i = 0; i < filesList.length; ++i) {
    if (!filesList[i]) continue;

    // If developer has forgot to put rootRes on, then we add it
    switch (typeof filesList[i]) {
      case "string":
        {
          if (filesList[i].indexOf(ReflexLoader.rootResDir) === -1) {
            filesList[i] = ReflexLoader.rootResDir + filesList[i];
          }
        }
        break;

      case "object": {
        if (filesList[i].file.indexOf(ReflexLoader.rootResDir) === -1) {
          filesList[i].file = ReflexLoader.rootResDir + filesList[i].file;
        }
      }
    }

    var lower = filesList[i];
    atlasName = ReflexLoader.fileAtlasData[lower];

    if (!atlasName) {
      // file not atlased
      if (typeof lower === "object") {
        if (
          checkForUndefined(
            loader.resources[lower.file] &&
              checkForUndefined(PIXI.utils.TextureCache[lower.file])
          )
        ) {
          let filename = gdk.ammendResourceName(lower.file);
          let metadata = {};

          // if it is a spine object we need to give it its meta data due to new crc requirements.
          // otherwise the atlas filename it tries to load will be the same as the json filename, but
          // it wont match due to the crc being different
          if (lower.isSpine) {
            metadata = ReflexLoader.createSpineMetadata(lower.file);
          }

          loader.add(lower.name, filename, {
            crossOrigin: "use-credentials",
            metadata: metadata,
          });
          filesToLoad++;
        }
      } else {
        if (
          checkForUndefined(loader.resources[lower]) &&
          checkForUndefined(PIXI.utils.TextureCache[lower])
        ) {
          let filename = gdk.ammendResourceName(lower);

          loader.add(lower, filename, { crossOrigin: "use-credentials" });
          filesToLoad++;
        }
      }
    } else {
      // file in an atlase, but is atlas loaded?
      if (!ReflexLoader.atlasesLoaded[atlasName].loaded) {
        // not loaded so add it to loader
        ReflexLoader.atlasesLoaded[atlasName].loaded = true;

        loader.add(atlasName, { crossOrigin: "use-credentials" });
        filesToLoad++;
      }
    }
  }

  ReflexLoader.currentID = ID;
  ReflexLoader.progressCallback = progressCallback;
  ReflexLoader.completeCallback = completeCallback;
  loader.on("progress", ReflexLoader.onAssetsLoadProgress);
  loader.on("error", ReflexLoader.onLoadError);
  loader.once("complete", ReflexLoader.onAssetsLoadComplete);
  loader.load();

  return filesToLoad;
};

ReflexLoader.onLoadError = function (error, loader, resource) {
  ReflexLoader.fatalError = true;
  systemOverlay.show(
    "There was an error loading the game\n\n" +
      resource.name +
      "\n\nPlease refresh your browser"
  );
};

ReflexLoader.onAssetsLoadProgress = function (loader, resourceLoaded) {
  if (ReflexLoader.fatalError) {
    return;
  }

  // Load progress
  ReflexLoader.progressCallback(
    ReflexLoader.currentID,
    resourceLoaded,
    loader.resources
  );
};

ReflexLoader.onAssetsLoadComplete = function (loader, resources) {
  if (ReflexLoader.fatalError) {
    return;
  }

  // Load complete
  ReflexLoader.completeCallback(ReflexLoader.currentID, resources);
};

// This function loads a single data file and calls back when complete
ReflexLoader.loadFile = function (filename, completeCallback) {
  ReflexLoader.loadFileCompleteCallback = completeCallback;
  ReflexLoader.filename = filename;

  resourceManager.oRequest = gdk.requestAsset(
    ReflexLoader.filename,
    function (assetName) {
      switch (resourceManager.oRequest.status) {
        case 200:
          {
            // File loaded successfully
            ReflexLoader.loadFileCompleteCallback(
              ReflexLoader.filename,
              resourceManager.oRequest.responseText
            );
          }
          break;

        case 404:
          {
            console.error(ReflexLoader.filename + " not found");
          }
          break;

        default:
          {
            console.error("Error loading config.json");
          }
          break;
      }
    }
  );
  resourceManager.oRequest.send(null);
};

ReflexLoader.GameLoader = function () {
  var _isLoaded = false;
  var _container = undefined;
  var _progressBar = undefined;
  this._loaderBackground = undefined;
  this._loadingText = undefined;
  this._graphics = undefined;

  this.initialise = function (container) {
    _container = container;

    resourceManager.registerLoadCompleteCallback(_onLoadComplete.bind(this));
    resourceManager.registerLoadProgressCallback(_onLoadProgress.bind(this));

    Reflex.registerEventHandler("ready", _onLayoutComplete.bind(this));
    Reflex.registerEventHandler("resize", _onResize.bind(this));

    messageBus.subscribe(
      "spinner:GameConfigEvent",
      _onGameConfigEvent.bind(this)
    );
  };
  this.initialiseLoader = function (container) {};

  var _onResize = function (width, height, isLandscape) {
    if (this._loaderBackground !== undefined) {
      var scale = Math.max(
        width / this._loaderBackground.texture.width,
        height / this._loaderBackground.texture.height
      );
      this._loaderBackground.scale.x = scale;
      this._loaderBackground.scale.y = scale;
      this._loaderBackground.position.x = width / 2;
      this._loaderBackground.position.y = height / 2;
    }
  };

  var _onLoadComplete = function (loadGroup) {
    if (loadGroup === "loading") {
      resourceManager.get("loadingContinue").visible = false;
      resourceManager.get("loadingProgressBackDark").tint = 0x222222;
      _progressBar = resourceManager.get("loadingProgressBack");
      this.setLoadProgress(0);
    }
  };

  var _onLoadProgress = function (percent, loadGroup) {
    if (loadGroup !== "loading") {
      this.setLoadProgress(percent);
    }
  };

  this.setLoadProgress = function (percent) {
    var width = _progressBar.texture.baseTexture.width * percent;
    var height = _progressBar.texture.baseTexture.height;
    _progressBar.texture.frame = new PIXI.Rectangle(0, 0, width, height);
  };

  var _onLayoutComplete = function () {
    this.setLoadProgress(1);
    // Make sure we are left in load screen state.
    _container.removeChild(this._loaderBackground);
    this._loaderBackground = undefined;
    _container.removeChild(this._loadingText);
    this._loadingText = undefined;
    _container.removeChild(this._graphics);
    this._graphics = undefined;

    this.layoutComplete();
    _isLoaded = true;
  };

  this.layoutComplete = function () {
    Reflex.deregisterEventHandler("ready", _onLayoutComplete.bind(this));

    Reflex.deregisterEventHandler("resize", _onResize.bind(this));
  };

  var _onGameConfigEvent = function (gameConfigTask) {
    // Allow player to click through load screen
    resourceManager.get("loadingContinue").visible = true;
    resourceManager.get("loadingProgressBack").visible = false;
    resourceManager.get("loadingProgressFront").visible = false;
    resourceManager.get("loadingProgressBackDark").visible = false;

    game.loadingBackground = resourceManager.get("background");
    game.loadingBackground.setInteractiveCallbacks(gdk.loadingClosed, true);

    gameData.slotConfig = gameConfigTask.data.slotConfig;
    gameData.reels = [];
    gameData.reelAnimations = [];
    gameData.lastReelPositions = [];

    var slotMachine = slotMachineFactory.getSlotMachine(0);
    slotMachine.selectReelMode("standard");

    var analyser = slotMachine.groupAnalysers["standard"];
    // All objects are created, so create game specific data
    for (var i = 0; i < 5; ++i) {
      var reel = resourceManager.get("slotContainer:reelContainer:reel" + i);

      //OG: Potentially need to expand pre/post apperature size here to
      //    account for above/below symbols being sent from the server

      var startingSymbols = gameConfigTask.data.slotConfig.startingSymbols[
        i
      ].symbols.map(function (x) {
        return parseInt(x.value);
      });
      if (analyser !== undefined) {
        if (analyser.analyse(startingSymbols, reel.postInjector)) {
          reel.preInjector.initialiseInjector({
            reelId: reel.reelIndex,
            minimumSymbols: 0,
            spinReversed: reel.spinParams.reverseSpin,
            requiredSymbols: reel.postInjector.bounceSymbols,
            symbolsLastDrawn: reel.postInjector.symbolsLastDrawn,
          });
        }
      }

      // Copy starting symbols from server
      var apperatureSize =
        reel.configParams.totalAppertureSize -
        (reel.configParams.preappertureSymbols +
          reel.configParams.postappertureSymbols);
      for (var j = 0; j < apperatureSize; ++j) {
        reel.setReelSymbol(j, startingSymbols[j]);
      }
      for (var j = 1; j <= reel.configParams.preappertureSymbols; ++j) {
        reel.setReelSymbol(
          -j,
          reel.preInjector.base.getValidSymbol([], reel.symbolData, 0)
        );
      }
      for (var j = 0; j < reel.configParams.postappertureSymbols; ++j) {
        if (reel.postInjector.postSymbols.length > 0) {
          reel.setReelSymbol(
            apperatureSize + j,
            reel.postInjector.postSymbols.pop()
          );
        } else {
          reel.setReelSymbol(
            apperatureSize + j,
            reel.postInjector.base.getValidSymbol(reel.symbolData, [], 0)
          );
        }
      }

      reel.postInjector.requiredSymbols = reel.preInjector.requiredSymbols;
      reel.spinCompleteCallback = gameController.onSpinComplete;

      gameData.reels.push(reel);
      gameData.reelAnimations.push(
        resourceManager.get(
          "slotContainer:reelContainer:reel" +
            i +
            ":animationStripContainer:" +
            "reelAnimStrip" +
            i
        )
      );
    }

    this.parseGameConfigEvent(gameConfigTask);
    // Link buttons to functions
    game.initialise(gameConfigTask);
  };
  this.parseGameConfigEvent = function (gameConfigTask) {};

  Object.defineProperty(this, "IsLoaded", {
    get: function () {
      return _isLoaded;
    },
  });
};
